import { Component, type ReactNode } from "react";
import { Button } from "@/components/ui/button";

/** One broken page must not blank the app: show what happened and a way back. Keyed by route, so navigating resets it. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
	state = { error: null as Error | null };

	static getDerivedStateFromError(error: Error) {
		return { error };
	}

	componentDidCatch(error: Error) {
		console.error(error);
	}

	render() {
		if (!this.state.error) return this.props.children;
		return (
			<div role="alert" className="mx-auto max-w-lg space-y-3 py-16 text-center">
				<h1 className="text-2xl font-semibold">Something went wrong on this page</h1>
				<p className="text-sm text-muted-foreground">Your worldview is safe: nothing is lost. Reload the page to try again.</p>
				<Button onClick={() => window.location.reload()}>Reload page</Button>
			</div>
		);
	}
}
